import { ChangeDetectionStrategy, Component, Renderer2 } from '@angular/core';
import { Store } from '@ngrx/store';
import { CoreUiPartialState, getArbCentralNavSecurity } from '@pos-app/core-ui';
import { NgIf } from '@angular/common';
import { MatIcon } from '@angular/material/icon';
import { MatDatepickerInput, MatDatepickerToggle, MatDatepicker } from '@angular/material/datepicker';
import { MatSuffix } from '@angular/material/form-field';

@Component({
    selector: 'app-action-cell',
    template: `
    <mat-icon
      *ngIf="!params.data.ticketsExistsTF && arbCentralSecurityFunctions?.manageTicketsActionTF"
      title="Raise new task"
      (click)="invokeAddNewTaskToOrder()"
      >note_add</mat-icon
    >
    <span
      *ngIf="params.data.ticketsExistsTF && arbCentralSecurityFunctions?.manageTicketsActionTF"
      title=" 'Review / update task for this order' "
      (click)="invokeLoadTask()"
      style="cursor: pointer"
    >
      <mat-icon
        class="stack-icon stack-top ml-1"
        color="warn"
        title="Add/ Review Tasks for this Order"
        style="font-size: 26px; height:36px; width:26px;"
      >
        priority_high
      </mat-icon>

      <svg
        style="vertical-align:top; padding-top:2px"
        xmlns="http://www.w3.org/2000/svg"
        height="24px"
        viewBox="0 -960 960 960"
        width="24px"
        fill="#000000"
      >
        <path
          d="M200-800v241-1 400-640 200-200Zm80 400h140q9-23 22-43t30-37H280v80Zm0 160h127q-5-20-6.5-40t.5-40H280v80ZM200-80q-33 0-56.5-23.5T120-160v-640q0-33 23.5-56.5T200-880h320l240 240v100q-19-8-39-12.5t-41-6.5v-41H480v-200H200v640h241q16 24 36 44.5T521-80H200Zm460-120q42 0 71-29t29-71q0-42-29-71t-71-29q-42 0-71 29t-29 71q0 42 29 71t71 29ZM864-40 756-148q-21 14-45.5 21t-50.5 7q-75 0-127.5-52.5T480-300q0-75 52.5-127.5T660-480q75 0 127.5 52.5T840-300q0 26-7 50.5T812-204L920-96l-56 56Z"
        />
      </svg>
    </span>
    <span *ngIf="params?.data?.salesperson">
      <mat-icon (click)="invokeChangeSalesPerson()" title="Change salesperson">supervisor_account</mat-icon>
    </span>
    <span style="margin-right:20px;">
      <mat-icon class="stack-icon " (click)="invokeLineAttachment(params.data.readOnlyLineYN === 'Y')" title="View order attachment">
        attachment
      </mat-icon>
      <mat-icon
        *ngIf="params.data.attachmentsExistsTF"
        (click)="invokeLineAttachment(params.data.readOnlyLineYN === 'Y')"
        class="stack-icon stack-top ml-1"
        color="warn"
        title="View line attachment"
      >
        priority_high
      </mat-icon>
    </span>
    <span 
   class="d-flex; justify-content-center"
      style="margin-top:-10px; margin-left:30px; position:absolute; background-color: #f5f5f5"
    >
      <input
        matInput
        [matDatepicker]="picker"
        (dateInput)="updateRequestDate($event.value)"
        style="padding: 0px; border-width: 0px; margin: 0px; width: 0; overflow: hidden"
      />
      <mat-datepicker-toggle
        matIconSuffix
        [for]="picker"
        (click)="openStream()"
        title="Update Order Request Date"
        style="padding-left:-10px"
      ></mat-datepicker-toggle>
      <mat-datepicker #picker></mat-datepicker>
    </span>
  `,
    changeDetection: ChangeDetectionStrategy.OnPush,
    styles: [
        `
      .btn {
        line-height: 0.5;
      }

      .dispatched {
        color: green;
      }

      .stack-icon {
        position: absolute;
      }

      .stack-top {
        z-index: 9;
      }
    `,
    ],
    imports: [NgIf, MatIcon, MatDatepickerInput, MatDatepickerToggle, MatSuffix, MatDatepicker]
})
export class CustomerQuoteOrderGridActionRenderComponent {
  params: any;
  lineAttachments: any[];
  arbCentralSecurityFunctions;

  constructor(private renderer: Renderer2, private coreUiStore: Store<CoreUiPartialState>) {}

  // Initialize component with parameters
  agInit(params: any): void {
    this.params = params;
    this.lineAttachments = params.data.attachmentIDArray;
    this.coreUiStore
      .select(getArbCentralNavSecurity)
      .pipe()
      .subscribe((data) => {
        this.arbCentralSecurityFunctions = data;
      });
  }

  // Invoke method to load parked order
  public invokeLoadParkedOrderMethod() {
    this.params.context.componentParent.loadParkedOrder({
      orderNumber: this.params.data.orderNumber,
      orderType: this.params.data.orderType,
    });
  }

  // Invoke method to remove parked order
  public invokeRemoveParkedOrderMethod() {
    this.params.context.componentParent.removeParkedOrder(
      {
        orderNumber: this.params.data.orderNumber,
        orderType: this.params.data.orderType,
      },
      this.isOrderChanged()
    );
  }

  // Invoke method to finalize order to JDE
  public invokeFinalizeOrderToJDEMethod() {
    this.params.context.componentParent.finaliseParkedOrderToJDE({
      orderNumber: this.params.data.orderNumber,
      orderType: this.params.data.orderType,
      email: this.params.data.userEmail,
    });
  }

  // Invoke method to fetch order from JDE
  public invokeFetchJDEOrderMethod() {
    this.params.context.componentParent.fetchOrderFromJDE({
      orderNumber: this.params.data.orderNumber,
      orderType: this.params.data.orderType,
    });
  }

  // Invoke method to handle line attachment
  public invokeLineAttachment(isReadOnly: boolean) {
    this.params.context.componentParent.attachedItem(this.params.data, isReadOnly);
  }

  // Check if the order has changed
  private isOrderChanged(): boolean {
    return this.params.data.orderChangedYN === 'Y';
  }

  // Update request date
  updateRequestDate(event: any) {
    this.params.context.componentParent.updateRequestDate(event.toLocaleDateString('it-IT'), this.params.data);
  }

  // Open date picker stream
  openStream() {
    const elements = document.querySelectorAll('mat-calendar');
    elements.forEach((element) => {
      const child = document.createElement('span');
      child.setAttribute(
        'style',
        'white-space: pre; align-items: center; display: flex; justify-content: center; background-color: #f5f5f5; padding: 5px;font-weight: bold;'
      );
      const newContent = document.createTextNode('Update Order Request Date');
      child.appendChild(newContent);
      this.renderer.insertBefore(element, child, element.childNodes[0]);
      // Increase the height of mat-calendar
      (element as HTMLElement).style.height = 'auto';
    });
  }

  // Invoke method to change salesperson
  public invokeChangeSalesPerson() {
    this.params.context.componentParent.changeSalesPerson(this.params.data);
  }

  invokeLoadTask() {
    this.params.context.componentParent.loadTask(this.params.data);
  }

  invokeAddNewTaskToOrder() {
    this.params.context.componentParent.addNewTaskForOrder(this.params.data);
  }
}

